export default __webpack_public_path__ + "static/media/rodeo-logistics-logo-white.c75cef84.png";